import React, { useRef } from "react";
import { InputGroup, Form, Button } from "react-bootstrap";
import { FaPaperPlane } from "react-icons/fa";
import ProtectedButton from "../RBAC/ProtectedButton";

const MessageBox = ({ message, setMessage, onSend, onFileSelect, disabled }) => {
  const fileInputRef = useRef(null);
  const textAreaRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (message.trim()) onSend(message.trim());
    }
  };

  const handleSendClick = () => {
    if (message.trim()) onSend(message.trim());
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && onFileSelect) {
      onFileSelect(file);
      e.target.value = ""; // reset input so same file can be uploaded again
    }
  };

  const handleInputChange = (e) => {
    setMessage(e.target.value);

    const textarea = textAreaRef.current;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  return (
    <div className="mt-auto pt-3 border-top bg-white p-2 d-flex flex-row justify-content-center align-items-center">
      <InputGroup>
        <Form.Control
          as="textarea"
          ref={textAreaRef}
          rows={1}
          placeholder="Write a message..."
          value={message}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          style={{
            resize: "none",
            borderTopLeftRadius: "6px",
            borderBottomLeftRadius: "6px",
            maxHeight: "150px",
            overflow: "hidden",
          }}
        />
        {/* Hidden File Input */}
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleFileChange}
        />

        {/* Upload Icon */}

      </InputGroup>
      <ProtectedButton
        permission="createMessage"
        variant="light"
        disabled={disabled}
        onClick={handleUploadClick}
        style={{
          border: "none",
          background: "transparent",
          padding: "0 8px",
        }}
      >
        <img
          src="/images/upload.svg"
          alt="upload"
          style={{ width: 40, cursor: "pointer", height: "100%" }}
        />
      </ProtectedButton>

      {/* Send Icon */}
      <ProtectedButton
        permission="createMessage"
        variant="dark"
        onClick={handleSendClick}
        disabled={disabled || !message.trim()}
        style={{
          border: "none",
          borderRadius: 0,
          padding: "6px 16px",
          height: "100%",
        }}
      >
        <FaPaperPlane />
      </ProtectedButton>
    </div>
  );
};

export default MessageBox;
